export default {
    translateUrl: '/directrequest/catalog/master/translate.json/',
    materialsUrl: '/directrequest/catalog/master/materials.json/',
    textUrl: '/directrequest/catalog/master/text.json/',
    findSensorUrl: '/directrequest/catalog/goods/find-sensor-by-marking.json/',
}
